import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { durationTotal } from '../../service/util';
import { useCheckinState, useSiteState } from '../../state/state';
import Moment from 'react-moment';

export const CheckoutSiteInfo = () => {
    const { lastCheckin } = useCheckinState();
    const {name} = useSiteState();

    return (
        <Row className="mb-3">
            <Col>
                <Row className="grouped py-3 mx-1 summary-block">
                    <Col>
                        <Row>
                            <Col className="med-heading">
                                <b>{name}</b>
                            </Col>
                        </Row>
                        {!lastCheckin?.checkinTime ? (
                            <Row>
                                <Col className="mb-1 sub-heading">
                                    No successful check in record exists.
                                </Col>
                            </Row>
                        ) : null}
                        {lastCheckin?.checkinTime ? (
                            <Row>
                                <Col className="mb-1 sub-heading">
                                    Check in at <Moment format="DD MMM YYYY, hh:mm a">{lastCheckin?.checkinTime}</Moment>
                                </Col>
                            </Row>
                        ) : null}
                        {lastCheckin?.checkinTime && lastCheckin?.checkoutTime ? (
                            <Row>
                                <Col className="mb-1 sub-heading">
                                    Check out at <Moment format="DD MMM YYYY, hh:mm a">{lastCheckin?.checkoutTime}</Moment>
                                </Col>
                            </Row>
                        ) : null}
                        {lastCheckin?.checkinTime && lastCheckin?.checkoutTime ? (
                            <Row>
                                <Col className="sub-heading">
                                    <strong>
                                        {durationTotal(lastCheckin?.checkinTime, lastCheckin?.checkoutTime)}
                                    </strong>
                                </Col>
                            </Row>
                        ) : null}
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
